import React from "react";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { useLocation } from "wouter";

/*
 * NavButton component
 * Button that navigates back in history
 */
export const NavButton: React.FC<{ navigationUrl?: string }> = ({ navigationUrl }) => {
  const [, setLocation] = useLocation();
  /* Handlers */
  const handleClick = () => {
    if (navigationUrl) {
      setLocation(navigationUrl);
    } else {
      history.back();
    }
  };

  return (
    <button onClick={handleClick} className={`btn btn-ghost p-2 h-auto min-h-max`}>
      <ChevronLeftIcon className="w-5 h-5 font-semibold" />
    </button>
  );
};
